import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import type { RangePickerProps } from 'antd/es/date-picker';
import { timeZoneOffset } from './time';

dayjs.extend(utc);
dayjs.extend(timezone);

export function dateShort(date: Date | string | Dayjs): string | null {
  return date ? dayjs.utc(date).local().format('MM-DD-YYYY') : null;
}
export function dateTime(
  date: Date | string | Dayjs,
  withMs?: boolean,
): string | null {
  // return date
  //   ? dayjs(date)
  //       .utc()
  //       .format(withMs ? 'hh:mm:ss SSS a' : 'hh:mm:ss a')
  //       .toString()
  //   : null;
  if (date) {
    const utcStr = dayjs(date).utc().format();
    return utcStr ? dayjs(utcStr).format('hh:mm:ss a') : null;
  }
  return '-';
}

export function dateFull(date: Date | string | Dayjs): string | null {
  if (date) {
    const utcStr = dayjs(date).utc().format();
    return utcStr ? dayjs(utcStr).format('YYYY-MM-DD HH:mm:ss') : null;
  }
  return '-';
}

export function ageFull(dateOfBirth: string | Dayjs): number | null {
  return dateOfBirth ? dayjs().diff(dayjs(dateOfBirth), 'year') : null;
}

export const disableDate: RangePickerProps['disabledDate'] = (selected) => {
  return selected && selected >= dayjs().endOf('day');
};

export function dayUTC(timestamp: any): number {
  const localTime = dayjs(timestamp).unix();
  const localTimezoneMinutes = 0 - new Date().getTimezoneOffset();
  return (localTime - localTimezoneMinutes * 60) * 1000;
}

export function UTCLocalTime(timestamp: Date | string | Dayjs): string | null {
  const utcStr = dayjs(timestamp).utc().format();
  const localTime = dayjs(utcStr).format('hh:mm:ss a');
  return localTime;
}

/**
 * UTC Convert TimeZoneTime
 * @param timeZoneOffset_ TimeZoneTime
 * @param time utc Time
 * @returns dayjs.Dayjs
 */
export function handleUTCConvertTimeZoneTime(
  timeZoneOffset_: number,
  time_?: string | Date | number,
): dayjs.Dayjs {
  return dayjs(
    dayjs
      .utc(time_)
      .add(timeZoneOffset_, 'second')
      .format('YYYY-MM-DD HH:mm:ss.SSS'),
  );
}

export function handlePatientTime(
  timeZoneName_: string,
  time_?: any,
): dayjs.Dayjs {
  return dayjs.tz(time_, timeZoneName_);
}

/**
 * TimeZoneTime To UTC
 * @param timeZoneOffset_ TimeZoneTime
 * @param time_ TimeZoneTime time
 * @returns
 */
export function handleTimeZoneTimeToUTC(
  timeZoneOffset_: number,
  time_?: string | Date | number,
): string {
  return dayjs(time_)
    .subtract(timeZoneOffset_ ?? 0, 'second')
    .format('YYYY-MM-DD HH:mm:ss.SSS');
}

/**
 * UTC时间转换为指定偏移量的本地时间
 * @param targetTimezone 目标时区名称 'America/New_York'
 * @param time_ UTC-0时间字符串 '2023-01-01 00:00:00'
 * @returns
 */
export function handleUTCConvertTimeZoneTimeNew(
  targetTimezone: string,
  time_: any,
): dayjs.Dayjs {
  const utcTime = dayjs.utc(time_); // 这是UTC-0时间
  const localTime = utcTime.tz(targetTimezone); // 将UTC-0时间转换为特定时区的本地时间
  return localTime;
}

/**
 * 指定偏移量的本地时间转换为UTC时间
 * @param targetTimezone 目标时区名称 'America/New_York'
 * @param time_ UTC-0时间字符串 '2023-01-01 00:00:00'
 * @returns
 */
export function handleTimeZoneTimeConvertUTCNew(
  targetTimezone: string,
  time_: string,
): dayjs.Dayjs {
  const localTime = dayjs.tz(time_, targetTimezone); // 使用时区名称
  const utcTime = localTime.utc(); // 将指定时区的时间转换为UTC时间
  return utcTime;
}

export function handleTimeZoneTime(
  targetTimezone: string,
  time_: string,
): dayjs.Dayjs {
  return dayjs.tz(time_, targetTimezone); // 使用时区名称
}

export function handleTimeZoneToUTC(
  timeZoneOffset_: number,
  timetamp_: number,
  millisecond: number,
): string {
  if (typeof timetamp_ === 'number' && typeof timeZoneOffset_ === 'number') {
    const newTimetamp =
      (timetamp_ + (timeZoneOffset() * 60 - timeZoneOffset_)) * 1000;
    return dayjs(newTimetamp)
      .utc()
      .millisecond(millisecond)
      .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  }
  return '';
}

/**
 * 指定偏移量的本地时间天开始转换为UTC时间
 * @param targetTimezone 目标时区名称 'America/New_York'
 * @param time_ UTC-0时间字符串 '2023-01-01 00:00:00'
 * @returns
 */
export function handleTimeZoneTimeStartOfDayConvertUTCNew(
  targetTimezone: string,
  time_: string,
): dayjs.Dayjs {
  const localTime = dayjs.tz(time_, targetTimezone).startOf('day'); // 使用时区名称
  const utcTime = localTime.utc(); // 将指定时区的时间转换为UTC时间
  return utcTime;
}

/**
 * 指定偏移量的本地时间天结束转换为UTC时间
 * @param targetTimezone 目标时区名称 'America/New_York'
 * @param time_ UTC-0时间字符串 '2023-01-01 00:00:00'
 * @returns
 */
export function handleTimeZoneTimeEndOfDayConvertUTCNew(
  targetTimezone: string,
  time_: string,
): dayjs.Dayjs {
  const localTime = dayjs.tz(time_, targetTimezone).endOf('day'); // 使用时区名称
  const utcTime = localTime.utc(); // 将指定时区的时间转换为UTC时间
  return utcTime;
}

export function roundUpToHour(timeString: string): string {
  // 提取年月日时分秒部分
  const [datePart, timePart] = timeString.split(' ');

  // 提取小时和分钟部分
  const [hour, minute] = timePart.split(':').map(Number);
  // 向上取整到最接近的小时
  let roundedHour = Math.ceil(hour);
  if (minute > 0) {
    roundedHour += 1;
  }

  // 构建向上取整的时间字符串
  const roundedTime = `${datePart} ${String(roundedHour).padStart(
    2,
    '0',
  )}:00:00`;

  return roundedTime;
}

export function roundDownToHour(timeString: string): string {
  // 提取年月日时分秒部分
  const [datePart, timePart] = timeString.split(' ');

  // 提取小时和分钟部分
  const [hour, minute] = timePart.split(':').map(Number);

  // 向下取整到最接近的小时
  const roundedHour = hour;

  // 构建向下取整的时间字符串
  const roundedTime = `${datePart} ${String(roundedHour).padStart(
    2,
    '0',
  )}:00:00`;

  return roundedTime;
}

/**
 * 将 UTC 时间转换为指定时区的本地时间
 * @param time_ UTC 时间字符串，例如 '2023-01-01 00:00:00'
 * @param timezoneName 时区名称，例如 'America/New_York'，若为空则使用 timeZoneOffset
 * @param timeZoneOffset 时区偏移量（秒），如 -14400，仅在 timezoneName 为空时生效
 * @returns 本地时间（Dayjs 对象）
 */
export function convertUTCToZoneTime(
  time_: string | number,
  timezoneName?: string | null,
  timeZoneOffset_?: number | null,
): dayjs.Dayjs {
  const utcTime = dayjs.utc(time_);

  if (!timezoneName) {
    return utcTime.add(timeZoneOffset_ ?? 0, 'second');
  }

  return utcTime.tz(timezoneName);
}

/**
 * 将某时区时间转换为 UTC 时间
 * @param time_ 本地时间字符串，例如 '2023-01-01 00:00:00'
 * @param timezoneName 时区名称，例如 'America/New_York'，若为空则使用偏移量
 * @param timeZoneOffset 时区偏移量（秒），如 -14400，仅在 timezoneName 为空时生效
 * @returns UTC 时间对象（Dayjs 实例）
 */
export function convertZoneTimeToUTC(
  time_: string,
  timezoneName?: string | null,
  timeZoneOffset_?: number | null,
): dayjs.Dayjs {
  if (!timezoneName) {
    return dayjs
      .utc(time_)
      .subtract(timeZoneOffset_ ?? 0, 'second')
      .utc();
  }
  const localTime = dayjs.tz(time_, timezoneName);
  return localTime.utc();
}
